module.exports = __webpack_public_path__ + "img/eggs.3d9e1384.webp";